import { getDuplicatedValues } from '../utils/getDuplicatedValues';
// Note: we should not rely on component ids being consistent across sessions
//.  updating this list will change component ids
export const STORAGE2_COMPONENT_NAMES = [
    'AdjustableDataComponent',
    'BlockConnectionHoleComponent',
    'CalculateCrossBraceComponent',
    'ColorComponent',
    'DisableColliderComponent',
    'EntityIsReplacingComponent',
    'HeightRestrictedComponent',
    'InsertAttachmentComponent',
    'InsertComponent',
    'LeftSideAttachedToComponent',
    'MergeableComponent',
    'MountingRailComponent',
    'NonWorldlyItemComponent',
    'OrganizersComponent',
    'ProhibitedReplacementComponent',
    'RemovedCrossBraceComponent',
    'RemovedLeftSideUnitComponent',
    'RemovedRightSideUnitComponent',
    'ReplaceEntityComponent',
    'RequestDestructionComponent',
    'RequestMergeComponent',
    'RequireSizeAdjustmentComponent',
    'ResizeComponent',
    'RightSideAttachedToComponent',
    'RoomChangedComponent',
    'SectionComponent',
    'StabilityZonesComponent',
    'StoredColliderDataComponent',
    'UprightComponent'
    // Add new component names here
];
// help avoid duplications from getting merged
const duplicatedComponentNames = getDuplicatedValues(STORAGE2_COMPONENT_NAMES);
if (duplicatedComponentNames.length) {
    throw new Error(`Duplicate entries in STORAGE2_COMPONENT_IDS are not allowed. The following appear multiple times: ${duplicatedComponentNames.map(s => JSON.stringify(s)).join(', ')}`);
}
// Historically this was set to ComponentIdSpan.CORE_TOOLBOX_BASE_ID + 1000, i.e. 106000, i.e. ComponentIdSpan.CORE_TOOLBOX_EXPERIMENTAL_BASE_ID by mistake
// (without registering ComponentIdSpan for e.g. ComponentIdSpan.STORAGETWO_RANGE_BASE_ID, and then colliding with CoreToolboxExperimentalComponentIds)
// https://github.com/inter-ikea/CBF-RE-IPEX-CORE/blob/master/core/api/src/commonMain/kotlin/com/ikea/core/component/ComponentIdSpan.kt
// See also formerly colliding component ids: https://github.com/inter-ikea/CBF-RE-IPEX-CORE/blob/master/packages/core-toolbox-experimental/src/CoreToolboxExperimentalComponentIds.ts
export const STORAGE2_BASE_ID = 80_000; // Between STORAGEONE_RANGE_BASE_ID (2_000) & SNYGGIS_BASE_ID (90_000);  -- Note: StorageOne uses substantially lower than 80_000 in practice
export const STORAGE2_COMPONENT_IDS = Object.fromEntries(STORAGE2_COMPONENT_NAMES.map((key, index) => [key, index + STORAGE2_BASE_ID]));
//# sourceMappingURL=storage2ComponentIDs.js.map